module.exports = __webpack_public_path__ + "files/ec8cb4a20f5cbcbafa1bf768be080221.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-bolditalic-webfont.ttf
// module id = 846
// module chunks = 60